import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextLink = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7085 9.46934C11.5567 9.2403 11.38 9.02295 11.1782 8.82115C10.2143 7.85724 8.89557 7.46433 7.64243 7.64243C6.78014 7.76497 5.94889 8.15788 5.28562 8.82115L4.10711 9.99966C2.47992 11.6268 2.47992 14.265 4.10711 15.8922C5.73429 17.5194 8.37248 17.5194 9.99966 15.8922L10.5889 15.303M8.29083 10.53C8.44258 10.759 8.61935 10.9764 8.82115 11.1782C9.78507 12.1421 11.1038 12.535 12.3569 12.3569C13.2192 12.2344 14.0504 11.8414 14.7137 11.1782L15.8922 9.99966C17.5194 8.37248 17.5194 5.73429 15.8922 4.10711C14.265 2.47992 11.6268 2.47992 9.99966 4.10711L9.41041 4.69636",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTextLink);
export default ForwardRef;
